module.exports = __webpack_public_path__ + "static/img/TYLAH-WILLIAMS.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TYLAH-WILLIAMS.jpg
// module id = mUSF
// module chunks = 0